// extracted by mini-css-extract-plugin
module.exports =  {"pip-overlay":"pip-overlay-tBjJU","exit-button":"exit-button-bWqw2","play-button":"play-button-Sj6WD","icon":"icon-JgOrO"};